import { Button, Grid, Paper } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNotifyMessage } from '../../../../hooks/useNotifyMessage';
import { savePolicy } from '../../../../services/policy.service';
import { useNavigate } from 'react-router';
import CustomModal from '../../../common/withModal';
import { tablePrimaryButtonSx } from '../../../../styles/tableButtonStyles';

export interface PolicyInput {
  name: string;
}

export default function PolicyForm() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { notifyMessage } = useNotifyMessage();
  const navigateTo = useNavigate();
  const initialValue = {
    name: '',
  } as PolicyInput;

  const validationSchema = () => {
    return Yup.object<PolicyInput>({
      name: Yup.string().required('Name is required'),
    });
  };
  const handleSubmit = async (values) => {
    const response = await savePolicy(values.name);

    if (response.status === 201) {
      notifyMessage('Policy created', 'success');

      navigateTo('/policies/' + response.data.id);

      return;
    }

    notifyMessage('Save FAILED', 'error');
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <Button variant='contained' size='small' onClick={() => setIsOpen(true)} sx={tablePrimaryButtonSx}>
        Add new policy
      </Button>
      <CustomModal
        maxWidth='lg'
        title='Add new policy'
        isOpen={isOpen}
        isValid={formik.isValid}
        setIsOpen={setIsOpen}
        onConfirm={formik.handleSubmit}
      >
        <Paper elevation={3} style={{ overflowX: 'auto' }}>
          <form onSubmit={formik.handleSubmit} style={{ width: 'auto', height: 'auto', padding: 20 }}>
            <Grid container spacing={3}>
              <Grid xs={12} item>
                <TextField
                  id='name'
                  name='name'
                  label='Name'
                  value={formik.values?.name ?? ''}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  placeholder='Name'
                  variant='standard'
                  size='small'
                  fullWidth
                  required
                  margin='dense'
                  style={{ width: 400 }}
                />
              </Grid>
            </Grid>
          </form>
        </Paper>
      </CustomModal>
    </>
  );
}
